import Header from '../../blocks/header/scripts.js'
import Hero from '../../blocks/hero/scripts.js'
import TextImg from '../../blocks/text-img/scripts.js'
import PictoList from '../../blocks/picto-list/scripts.js'
import Cards from '../../blocks/cards/scripts.js'
import Title from '../../blocks/title/scripts.js'
import TitleText from '../../blocks/title-text/scripts.js'
import ButtonHover from '../../blocks/button/scripts'
import Contact from '../../blocks/contact/scripts.js'
import Popup from '../../blocks/popup/scripts.js'
import { initReveal } from './utils/reveal.js'


document.addEventListener('DOMContentLoaded', () => {

  const header = document.querySelector('.header')
  if (header) new Header(header)

  document.querySelectorAll('.hero').forEach(el => new Hero(el))
  document.querySelectorAll('.text-img').forEach(el => new TextImg(el))
  document.querySelectorAll('.picto-list').forEach(el => new PictoList(el))
  document.querySelectorAll('.cards').forEach(el => new Cards(el))
  document.querySelectorAll('.title').forEach(el => new Title(el))
  document.querySelectorAll('.title-text').forEach(el => new TitleText(el))
  document.querySelectorAll('.contact').forEach(el => new Contact(el))
  document.querySelectorAll('.popup').forEach(el => new Popup(el))

  const buttonElements = document.querySelectorAll('[data-block="button"]');
  buttonElements.forEach((buttonElement) => {
    new ButtonHover(buttonElement);
  });

  initReveal()
});
